module.exports = __webpack_public_path__ + "img/lucky-draw-instant-prize.cd305b3f.webp";